import { Component } from '@angular/core';
import { FormConfig, CustomFormAccessor } from '../form-cva.component';
import { Address } from 'src/shared/api';
import { NgControl, FormBuilder } from '@angular/forms';
import { filterStates } from 'src/shared/utilities/utility-functions';
import { CustomValidators } from 'src/shared/validators/custom-validators';

const addressFormConfig: FormConfig<Address> = {
	id: [''],
	address1: [''],
	address2: [''],
	city: [''],
	state: ['', [CustomValidators.isValidState]],
	zipCode: [''],
	country: [''],
	description: [''],
};

@Component({
	selector: 'rpshared-address',
	templateUrl: './address.component.html',
})
export class AddressComponent extends CustomFormAccessor<Address> {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, addressFormConfig);
	}

	filteredStates$ = filterStates(this.form.get('state'));
}
